import { useState } from 'react';
import { Editor } from '@tiptap/react';

export const useVideoDialog = (editor: Editor) => {
  const [isVideoDialogOpen, setIsVideoDialogOpen] = useState(false);
  const [videoUrl, setVideoUrl] = useState('');

  const openVideoDialog = () => {
    if (editor) {
      setIsVideoDialogOpen(true);
    }
  };

  const addVideo = () => {
    if (videoUrl && editor) {
      try {
        console.log("Tentative d'ajout de vidéo:", videoUrl);
        // YouTube
        const youtubeRegex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/;
        const youtubeMatch = videoUrl.match(youtubeRegex);
        
        // S'assurer que l'éditeur est à jour avant d'ajouter la vidéo
        editor.commands.focus();
        
        if (youtubeMatch && youtubeMatch[1]) {
          const videoId = youtubeMatch[1];
          
          // Insert video directly using the VideoExtension
          editor.commands.setVideo({
            src: videoId,
            provider: 'youtube'
          });
          
          console.log("Vidéo YouTube ajoutée:", videoId);
          console.log("État de l'éditeur après ajout:", editor.getHTML());
          
          // Vérifier si la vidéo est correctement ajoutée dans le DOM
          setTimeout(() => {
            const iframes = document.querySelectorAll('iframe[src*="youtube.com"]');
            console.log("Nombre d'iframes YouTube dans le DOM:", iframes.length);
            iframes.forEach((iframe, i) => {
              console.log(`Iframe ${i}:`, iframe.outerHTML);
            });
          }, 100);
        } 
        // Vimeo
        else if (videoUrl.includes('vimeo.com')) {
          const vimeoRegex = /vimeo\.com\/(\d+)/;
          const vimeoMatch = videoUrl.match(vimeoRegex);
          
          if (vimeoMatch && vimeoMatch[1]) {
            const vimeoId = vimeoMatch[1];
            
            editor.commands.setVideo({
              src: vimeoId,
              provider: 'vimeo'
            });
            
            console.log("Vidéo Vimeo ajoutée:", vimeoId);
            console.log("État de l'éditeur après ajout:", editor.getHTML());
          }
        } 
        // Dailymotion
        else if (videoUrl.includes('dailymotion.com') || videoUrl.includes('dai.ly')) {
          const dailymotionRegex = /(?:dailymotion\.com\/video|dai\.ly)\/([a-zA-Z0-9]+)/;
          const dailymotionMatch = videoUrl.match(dailymotionRegex);
          
          if (dailymotionMatch && dailymotionMatch[1]) {
            const dailymotionId = dailymotionMatch[1];
            
            editor.commands.setVideo({
              src: dailymotionId,
              provider: 'dailymotion'
            });
            
            console.log("Vidéo Dailymotion ajoutée:", dailymotionId);
            console.log("État de l'éditeur après ajout:", editor.getHTML());
          }
        } 
        // Other video URLs - create a simple link
        else {
          const linkHTML = `<a href="${videoUrl}" target="_blank" rel="noopener noreferrer" class="video-link">Vidéo externe: ${videoUrl}</a>`;
          editor.commands.insertContent(linkHTML);
          console.log("Lien vidéo ajouté:", videoUrl);
          console.log("État de l'éditeur après ajout:", editor.getHTML());
        }
      } catch (error) {
        console.error("Erreur lors de l'ajout de la vidéo:", error);
      }
      
      // Clear input and close dialog
      setVideoUrl('');
      setIsVideoDialogOpen(false);
    }
  };

  return {
    isVideoDialogOpen,
    setIsVideoDialogOpen,
    videoUrl,
    setVideoUrl,
    openVideoDialog,
    addVideo
  };
};
